module.exports = __webpack_public_path__ + "img/info_listing1.01728198.01728198.jpg";